import React from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyles from '@/styles/globalStyle';
import theme from '@/styles/themes';

const StyledComponent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <>{children}</>
    </ThemeProvider>
  );
};

export default StyledComponent;
